import { render, staticRenderFns } from "./InvoiceRetrieval.vue?vue&type=template&id=3defb520&scoped=true"
import script from "./InvoiceRetrieval.vue?vue&type=script&lang=js"
export * from "./InvoiceRetrieval.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRetrieval.vue?vue&type=style&index=0&id=3defb520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defb520",
  null
  
)

export default component.exports